import { forwardRef } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import MUIDialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import { Spacings } from '@styles/index';
import { getImage } from '@utils/imageHelper';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledBottomSheet = styled(MUIDialog)`
  &.MuiDialog-root .MuiDialog-container .MuiPaper-root {
    margin: 0px;
    position: absolute;
    bottom: 0px;
    background: var(--color-base-1);

    &.MuiDialog-paperWidthFalse {
      max-width: 100%;
    }
    &.MuiDialog-paperFullWidth {
      width: 100%;
    }

    &.MuiPaper-rounded {
      border-radius: ${Spacings.SPACING_0B};
      border-top-left-radius: ${Spacings.SPACING_4B};
      border-top-right-radius: ${Spacings.SPACING_4B};
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  ${({ $rawStyle }) => $rawStyle}
`;

const IconContainer = styled.div`
  position: absolute;
  right: ${Spacings.SPACING_4B};
  top: ${Spacings.SPACING_4B};
  cursor: pointer;
`;

const Close = styled.img``;

const BottomSheet = ({
  open,
  onClose,
  children,
  fullScreen,
  className,
  contentContainerStyle,
  icon
}) => (
  <StyledBottomSheet
    fullWidth
    fullScreen={fullScreen}
    maxWidth={false}
    disableEscapeKeyDown
    open={open}
    TransitionComponent={Transition}
    onClose={onClose}
    className={className}
  >
    {onClose && (
      <IconContainer>
        {icon || (
          <Close
            src={getImage('combat/close-circle-filled.svg')}
            onClick={onClose}
            alt="close"
          />
        )}
      </IconContainer>
    )}
    <Wrapper $rawStyle={contentContainerStyle}>{children}</Wrapper>
  </StyledBottomSheet>
);

export default BottomSheet;

BottomSheet.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  fullScreen: PropTypes.bool,
  className: PropTypes.string,
  contentContainerStyle: PropTypes.string,
  icon: PropTypes.node
};

BottomSheet.defaultProps = {
  open: false,
  onClose: null,
  fullScreen: false,
  className: '',
  contentContainerStyle: '',
  icon: null
};
